import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";

export function ProductRating({
  product,
}: Pick<CardComponentProps, "product">) {
  if (
    !product.reviewSummary ||
    !product.reviewSummary.averageRating ||
    !product.reviewSummary.numberOfReviews
  ) {
    return null;
  }
  const rating = {
    reviews: product.reviewSummary.numberOfReviews,
    averageRating: product.reviewSummary.averageRating,
  };

  return (
    <PDPLink product={product} componentName="ProductRating">
      <Rating rating={rating} />
    </PDPLink>
  );
}
